// CODICE models\mappers\pagination-mapper.ts

import type { PaginationDTO } from '../dto/pagination-dto'
import type { Pagination } from '../pagination'

const mapToPaginationDTO = (pagination: Pagination): PaginationDTO => {
    return {
        currentPage: pagination.page,
        nextPage: pagination.nextPage,
        numberOfPage: pagination.totalPages,
        totalRecord: pagination.totalItems,
    }
}

const mapToPagination = (paginationDTO: PaginationDTO): Pagination => {
    return {
        page: paginationDTO.currentPage,
        nextPage: paginationDTO.nextPage,
        totalItems: paginationDTO.totalRecord,
        totalPages: paginationDTO.numberOfPage,
    }
}

export { mapToPagination, mapToPaginationDTO }
